import meta from '../metas/rate';
export default {
  meta,
  computed: {
    attrs() {
      const {
        $attrs
      } = this;
      return { ...$attrs,
        max: +$attrs.max
      };
    }

  }
};